export class InvoiceRowResponse
{
    public readonly purchaseType:any;
    public readonly description:string;
    public readonly subscriptionId:number;
    public readonly fromDate:number;
    public readonly toDate:number;
    public readonly quantity:number;
    public readonly unitPrice:number;
    public readonly unitPeriod:any;
    public readonly rowAmount:number;

    constructor(json:any)
    {
        this.purchaseType = json['purchaseType'];
        this.description = json['description'];
        this.subscriptionId = json['subscriptionId'];
        this.fromDate = json['fromDate'];
        this.toDate = json['toDate'];
        this.quantity = json['quantity'];
        this.unitPrice = json['unitPrice'];
        this.unitPeriod = json['unitPeriod'];
        this.rowAmount = json['rowAmount'];
    }
}
